import {
  IDataQueriesDispatcher,
  IPaylodAction,
  IActionDispatcher,
  IFeatureTablesDispatcher
} from '../../interfaces/dispatchers'
import DataQueriesActions from '../../enums/ActionTypes/DataQueriesActions'
import {IStore, IControlQueries, IRawQueries, IDataQuery, IGeometryQuery, QueryTarget} from '../../interfaces/reducers'

export class DataQueriesDispatcher implements IDataQueriesDispatcher {
  dataTablesDispatcher: IFeatureTablesDispatcher
  constructor(dataTablesDispatcher: IFeatureTablesDispatcher) {
    this.dataTablesDispatcher = dataTablesDispatcher
    this.setQueries = this.setQueries.bind(this)
  }

  protected computeWhere(dataQuery: IDataQuery) {
    const dataWheres: string[] = []
    const mapDataWheres: string[] = []
    for (const key in dataQuery.controledQueries) {
      if (dataQuery.controledQueries[key].where) {
        if (dataQuery.controledQueries[key].queryTarget & QueryTarget.Data) {
          dataWheres.push(dataQuery.controledQueries[key].where)
        }
        if (dataQuery.controledQueries[key].queryTarget & QueryTarget.Map) {
          mapDataWheres.push(dataQuery.controledQueries[key].where)
        }
      }
    }
    for (const key in dataQuery.rawQueries) {
      if (dataQuery.rawQueries[key].where) {
        if (dataQuery.rawQueries[key].queryTarget & QueryTarget.Data) {
          dataWheres.push(dataQuery.rawQueries[key].where)
        }
        if (dataQuery.rawQueries[key].queryTarget & QueryTarget.Map) {
          mapDataWheres.push(dataQuery.rawQueries[key].where)
        }
      }
    }
    dataQuery.dataWhere = dataWheres.join(' AND ')
    dataQuery.mapDataWhere = mapDataWheres.join(' AND ')
  }

  public setQueries(
    key: string,
    controlQueries?: IControlQueries,
    rawQueries?: IRawQueries,
    geometryQuery?: IGeometryQuery,
    updateClients: boolean = true
  ) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const infos = getStore().layerInfos.featureLayerInfos
      const allQueries = getStore().dataQueries
      let dataQuery: IDataQuery = {
        controledQueries: {},
        rawQueries: {}
      }
      if (allQueries[key]) {
        dataQuery = {...allQueries[key]}
      }
      if (controlQueries) {
        dataQuery.controledQueries = {...dataQuery.controledQueries, ...controlQueries}
      } else {
        dataQuery.controledQueries = {}
      }
      if (rawQueries) {
        dataQuery.rawQueries = {...dataQuery.rawQueries, ...rawQueries}
      } else {
        dataQuery.rawQueries = {}
      }
      dataQuery.geometryQuery = geometryQuery
      this.computeWhere(dataQuery)

      dispatch({
        type: DataQueriesActions.UPDATE_SOURCE_QUERIES,
        payload: {[key]: dataQuery}
      })
      if (updateClients) {
        if ((dataQuery.mapDataWhere || (allQueries[key] && allQueries[key].mapDataWhere)) && infos[key]) {
          infos[key].refresh()
        }
        dispatch(this.updateClients(key))
      }
    }
  }

  protected updateClients(key: string) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      setTimeout(() => {
        dispatch(this.dataTablesDispatcher.refrashTable(key))
      }, 50)
    }
  }
}
